// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"121":"gallery","136":"events","177":"home","342":"press","466":"weddings","631":"contact","860":"menu","913":"default"}[chunkId] || chunkId) + "." + __webpack_require__.h() + ".chunk.js";
};